import _Vue from "vue";
import {Moment} from "moment";
import moment from 'moment-timezone/builds/moment-timezone-with-data';
import {DataHelper} from "../../utils/data-helper";
import {DEFAULT_NUMBER_DECIMAL} from "../../common/constants";

export class PluginOptions {
}

const FormatterPlugin = {
	install(Vue: typeof _Vue , options?: PluginOptions) {
        console.log("FormatterPlugin plugin is installing");
        
        Vue.prototype.$formatAppoimentDate = function (value: string) { 
            let lang = localStorage.getItem('lang').split('-')[0];
            if (lang === 'nl')
                return moment(value).locale('nl').format('ddd DD/MM HH:mm');
            if (lang === 'fr')
                return moment(value).locale('fr').format('ddd DD/MM HH:mm');
            return moment(value).locale('en').format('ddd DD/MM HH:mm');
        }
		
		/**
		 * format date by locale
		 * note: this is format using for element ui date time picker
		 * i had replace some format from moment because element ui using another format
		 * IMPORTANT: BY REQUEST CHANGE THAT DO NOT USING THE FORMAT BY MOMENT AND HARD CODE FORMAT BY LANGUAGE
		 */
		Vue.prototype.$formatDate = function () {
			let localeData = moment.localeData() as any;
			//console.log("time-zone--localeData: ", localeData);
			//console.log("time-zone--localeData_abbr: ", localeData._abbr);
			
			switch (localeData._abbr) {
				case "en":
					return "MM/dd/yyyy"
				case "nl":
					return "dd/MM/yyyy"
				case "fr":
					return "dd/MM/yyyy"
				default:
					return "MM/dd/yyyy"
			}
		};
		
		/**
		 * FORMAT DATE USING FOR MOMEMTN
		 */
		Vue.prototype.$formatDateMoment = function () {
			let localeData = moment.localeData() as any;
			switch (localeData._abbr) {
				case "en":
					return "MM/DD/YYYY"
				case "nl":
					return "DD/MM/YYYY"
				case "fr":
					return "DD/MM/YYYY"
				default:
					return "MM/DD/YYYY"
			}
		};
		
		/**
		 * FORMAT DATE USING FOR MOMEMTN
		 */
		Vue.prototype.$formatDateMonthMoment = function () {
			let localeData = moment.localeData() as any;
			switch (localeData._abbr) {
				case "en":
					return "MMM DD"
				case "nl":
					return "DD MMM"
				case "fr":
					return "DD MMM"
				default:
					return "MMM DD"
			}
		};

		Vue.prototype.$formatTime = function () {
			return "HH:mm:ss";
		};
		
		/**
		 * FORMAT DATETIME FOR ELEMENT UI
		 */
		Vue.prototype.$formatDateTime = function () {
			let self = this as any;
			return self.$formatDate() + " " + self.$formatTime();
		};
		
		Vue.prototype.$nf = function (value: any) {
			if (value !== undefined && value !== null)
				return Intl.NumberFormat(this.$i18n.locale , {
					maximumFractionDigits: DEFAULT_NUMBER_DECIMAL.maximumFractionDigits
				}).format(value);
			else return value;
		};
		
		Vue.prototype.$currencyFormat = function (value: any) {
			if (value == null) return 0;
			const lang = localStorage.getItem("lang");
			
			return value.toLocaleString(lang , {
				minimumFractionDigits: 2 ,
				maximumFractionDigits: 2
			});
		};
		
		Vue.prototype.$getStaticUrl = (path) => {
			return DataHelper.getStaticRootUrl() + path;
		};
		
		Vue.prototype.$getMomentByLocale = function (): Moment {
			moment.updateLocale(this.$i18n.locale.substr(0 , 2) , {
				week: {
					dow: 1 ,
					doy: 7
				}
			});
			return moment();
		};
		
		Vue.prototype.$formatDateByLocale = function (value: string) {
			let format = this.$formatDate();
			let date = moment(value);
			if (!date.isValid()) return value;
			return date.format(format.toUpperCase());
		};
		
		Vue.prototype.$formatDateTimeByLocale = function (value: string) {
			let format = this.$formatDateMoment() + " " + this.$formatTime();

			//Read datetime from API as (GMT+1)/ GMT+2 (for Task module)
			let date = moment.tz(value, "Europe/Brussels");
			if (!date.isValid()) return value;
			
			return moment.utc(date.format()).local().format(format);
		}

		Vue.prototype.$formatDateTimeFromUTCToLocale = function (value: string) {
			let format = this.$formatDateMoment() + " " + this.$formatTime();

			let date = moment.utc(value);

			if (!date.isValid()) return value;
			
			return moment.utc(value).local().format(format);
		}

		Vue.prototype.$formatDateTimeFromUTCToEndOfDayLocale = function (value: string) {
			let format = this.$formatDateMoment() + " " + this.$formatTime();

			let date = moment.utc(value);

			if (!date.isValid()) return value;
			
			return moment.utc(value).local().endOf('day').format(format);
		}

		Vue.prototype.$isExpired = function (value: string) {
			const expiredDateTime = this.$formatDateTimeFromUTCToEndOfDayLocale(value);
			let format = this.$formatDateMoment() + " " + this.$formatTime();

			return moment().startOf('day').isAfter(moment(expiredDateTime, format));
		}

		Vue.prototype.$formatDateByLocale = function (value: string) {
			let format = this.$formatDateMoment();

			//Read datetime from API as (GMT+1)/ GMT+2 (for Task module)
			let date = moment.tz(value, "Europe/Brussels");
			if (!date.isValid()) return value;
			
			return moment.utc(date.format()).local().format(format);
		}

		Vue.prototype.$formatDateTimeAsServer = function (value: string) {

			// Parse datetime of current locale into server locale (GMT+1)/(GMT+2)
			let date = moment(value).tz("Europe/Brussels");
			if (!date.isValid()) return value;
			return date.format();
		}
	}
};

export default FormatterPlugin;

declare module 'vue/types/vue' {
	interface Vue {
		$getMomentByLocale: () => Moment;
		$formatDateByLocale: (value: string) => String;
		$formatDateTimeByLocale: (value: string) => String;
		$formatDateTimeAsServer: (value: string) => String;
	}
}

